export default "__VITE_ASSET__BksdfR2M__"